import dir from "@/styles/modules/directions.module.scss";
import * as C from "@components";
import {Width} from "@components";
import React from "react";
import * as Api from "@api";
import clsx from "clsx";
import {ModalVideoFromImageBlock, ModalVideoFromImageBlockProps} from "@/app/parts/global/ModalVideoFromImage";


export interface FillingCappingSubHeroSectionItemProps {
    label: string;
    link: string;
}

export interface FillingCappingSubHeroSectionProps {
    content: Api.ContentItem;
    items: FillingCappingSubHeroSectionItemProps[];
    cols?: number;
    video: ModalVideoFromImageBlockProps[]
}

export const FillingCappingSubHeroSection = ({content, items, cols = 2, video}: FillingCappingSubHeroSectionProps) => {
    const itemsPerCol = Math.ceil(items.length / cols);

    const columns = Array.from({length: cols}, (_, i) =>
        items.slice(i * itemsPerCol, (i + 1) * itemsPerCol)
    );

    return (
        <section className={dir.directions_block}>
            <div className={`container ${dir.directions_container}`}>
                <C.PageContent
                    data={content.data}
                    type={content.type}
                    typography={C.Typography.H4}
                    className={dir.subhero_title}
                    maxWidth={Width.W1038}
                    centered
                />

                {/* Відео-блок */}
                <div className="w-full flex flex-col md:flex-row justify-evenly gap-4">
                    {video.map((v) => (
                        <div key={v.id} className="flex flex-col gap-2">
                            <ModalVideoFromImageBlock {...v} />
                            {v?.title && <p className="text-center w-2/3 mx-auto">{v.title}</p>}
                        </div>
                    ))}
                </div>

                <div className="md:flex gap-x-10">
                    {columns.map((colItems, colIndex) => (
                        <div key={colIndex}>
                            {colItems.map((item, index) => (
                                <div key={index} className={cols === 1 ? dir.subhero_item_single : dir.subhero_item}>
                                    <a href={item.link}>
                                        <div
                                            className={cols === 1 ? dir.subhero_item_single__text : dir.subhero_item__text}>
                                            {item.label}
                                        </div>
                                    </a>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}